<template>
<div>
  <div>
    <Drag
      horizontalLock
      :initPosition="{}"
      @handleDragClick='handleShowPad'
    >
      <template v-if="$route.name === 'orderedSong'">
        <div
          class="ordered-song-float"
          :class="{ 'is-bottom-position': isControlBottom }"
          @click="handleClickControlItem('遥控', 'fixedEntrance')"
          data-name="遥控"
          src="https://qncweb-back1.ktvsky.com/20230613/other/51ac491061dc92d9109b73cfe7171519.png"
        >
          <img
            class="play-control-float-img"
            src="https://qncweb.ktvsky.com/20251217/vadd/731c01852d48a67df82d019b038da9e0.png"
            alt="遥控"
          >
        </div>
      </template>
      <template v-else>
        <div
          class="play-control-float"
          :class="{ 'is-bottom-position': isControlBottom }"
          @click="handleClickControlItem('遥控', 'fixedEntrance')"
          data-name="遥控"
          src="https://qncweb-back1.ktvsky.com/20230613/other/51ac491061dc92d9109b73cfe7171519.png"
        >
            遥控
        </div>
      </template>
    </Drag>
  </div>
  <control-pad v-if="showPad"></control-pad>
  <NoRights></NoRights>
</div>
</template>
<script>
import NoRights from '@/components/app/adsense/no_rights';
import { utils } from '@/libs/interfaces';
import { mapState } from 'vuex';
import ControlPad from './control_pad';

export default {
  name: 'PlayControl',
  data() {
    return {
      // 将要插入的元素包一层结构，便于floa-fold组件内部控制
      controlItems: [{
        name: '遥控',
        icon: 'https://qncweb-back1.ktvsky.com/20210702/vadd/bdd75ba31e04c7cd16da0b64646f627f.png',
        isFold: false, // 是否可折叠 否
      }, {
        name: '已点',
        icon: 'https://qncweb-back1.ktvsky.com/20210702/vadd/020116a92445d7bf9e27e369bb9d6980.png',
        isFold: true, // 是否可折叠 可
        flag: {
          type: 'number',
          value: 0,
        },
      }],
      floatFoldTimer: 0,
    };
  },
  watch: {
    $route(val) {
      if (this.$refs.floatFold) {
        if (utils.cookie.getCookie('showFloatUnFold')) {
            this.$refs.floatFold.fold();
            return;
        }
        this.$refs.floatFold.unFold();
        utils.cookie.setCookie(1, 0.25, 'showFloatUnFold');
        if (val.name !== 'home') {
            this.fold();
        }
        }
    },
  },
  computed: {
    ...mapState({
      showPad: (state) => state.showPad,
      special_control: (state) => state.special_control,
      isControlBottom: (state) => state.isControlBottom,
      positionStyle() {
        return `bottom: ${this.special_control};`;
      },
    }),
  },
  methods: {
    handleClickDrag(e) {
      const name = e.target.dataset.name || e.srcElement.dataset.name;
      switch (name) {
        case 'arrowLeft':
          this.$refs.floatFold.unFold();
          break;
        case 'arrowRight':
          this.$refs.floatFold.fold();
          break;
        default:
          this.handleClickControlItem(name);
          break;
      }
    },
    handleFold() {
      clearTimeout(this.floatFoldTimer);
    },
    handleUnFold() {
      this.floatFoldTimer = setTimeout(this.$refs.floatFold.fold, 5000);
    },
    handleWindowScroll() {
      // 已经是折叠状态 就直接返回
      if (this.$refs.floatFold.isFold) return;
      this.$refs.floatFold.fold();
    },
    // 新版播控入口和旧版入口埋点区分
    handleClickControlItem(name, type = '') {
      this.$sendLog({
        event_type: 'click',
        event_name: '固定浮窗',
        event_data: {
          name: type === 'fixedEntrance' ? `新版${name}` : name,
          position: this.$route.name,
        },
      });
      if (name === '遥控') {
        this.handleShowPad();
        return;
      }
      if (name === '已点') {
        if (this.$route.name === 'orderedSong') return
        this.$router.push('/thunder/ordered?fromType=playcontrol');
      }
    },
    handleShowPad() {
      this.$sendLog({
        event_type: 'click',
        event_name: '固定浮窗',
        event_data: {
          name: '新版遥控',
          position: this.$route.name,
        },
      });
      this.$store.commit('SET_CONTROL_PAD', true);
    },
  },
  components: {
    Drag: () => import('@/components/common/drag/drag'),
    ControlPad,
    NoRights,
  },
};
</script>
<style lang="scss" scoped>
.play-control-float {
  position: fixed;
  width: 140px;
  height: 140px;
  background: #00000099 url('https://qncweb-back1.ktvsky.com/20230803/other/5a84f4ef407d233bca3abf8d1fecd4cc.png') no-repeat;
  background-size: 51px auto;
  background-position: 50px 20px;
  box-shadow: 0 2px 10px 0 #0000004d;
  border-radius: 70px;
  backdrop-filter: blur(21px);
  right: 40px;
  bottom: 120px;
  z-index: $z_index_one;
  font-weight: 500;
  font-size: 22px;
  color: #FFFFFF;
  padding-top: 90px;
  text-align: center;
  &.is-bottom-position {
    bottom: 30vw;
  }
}
html[data-theme='light'] {
  .play-control-float {
    background: #292933 url('https://qncweb-back1.ktvsky.com/20240222/vadd/d94759dbab76c00c1d320ea25785f34e.png') no-repeat 35px 20px;
    background-size: 70px 70px;
  }
}
.play-control-float-img {
  width: 130px;
  height: 130px;
}
.fixed-play-control {
  position: fixed;
  display:flex;
  transform: translateX(-50%);
  left: 50%;
  bottom: 140px;
  z-index: $z_index_one;
  width: 380px;
  height: 80px;
  background: #706DFF;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,0.30);
  border-radius: 50px;
  font-size: 28px;
  color: #FFFFFF;
  align-items: center;
  .btn-wrap {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 34px;
      height: 34px;
      margin-right: 10px;
    }
  }
  .play {
    &::after {
      display: block;
      position: absolute;
      content:"";
      width: 1px;
      height: 40px;
      opacity: 0.3;
      background: #EBEBEB;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.ordered-song-float {
  position: fixed;
  right: 20px;
  bottom: 180px;
  width: 178px;
  height: 166px;
  z-index: $z_index_one;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
